import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const updateUserPasswordApi = createAsyncThunk(
  "updateUseData",
  async (userData) => {
    const updateUserData = new FormData();

    updateUserData.append("newPassword", userData.newPassword);

    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/resetPassword/${userData.userId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
        body: updateUserData,
      }
    )
      .then((respons) => respons.json())
      .then((resulet) => {
        return resulet;
      })
      .catch((e) => {
        formatError(e);
        return e;
      });

    return request;
  }
);
function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const updateUserPasswordSlicer = createSlice({
  name: "updateUserPassword",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserPasswordApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateUserPasswordApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Password updated Successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });

    builder.addCase(updateUserPasswordApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default updateUserPasswordSlicer.reducer;
